import { createContext } from 'react';

/**
 * Initializes a context for sharing field definitions in complex,
 * deeply nested forms/form fields
 */
export const FieldDefinitionsContext = createContext({});
